import React, { useEffect, useState, useRef } from "react";
import ongoingVendorService from "../../services/ongoing-vendor";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_green.css";
const renderBookStatusBadge = (bookStatus) => {
  let badgeClass = "outlined-badge badge-purple";
  switch (bookStatus) {
    case "Success":
      badgeClass = "outlined-badge badge-green";
      break;
    case "Initiated":
      badgeClass = "outlined-badge badge-gray";
      break;
    case "Vendor Assigned":
      badgeClass = "outlined-badge badge-blue";
      break;
    case "Vendor Re-Assigned":
      badgeClass = "outlined-badge badge-yellow";
      break;
    case "Vendor Re-Quoted":
      badgeClass = "outlined-badge badge-purple";
      break;
    case "Re-Quote Accepted":
      badgeClass = "outlined-badge badge-blue";
      break;
    case "Cancelled":
      badgeClass = "outlined-badge badge-orange";
      break;
    case "Completed":
      badgeClass = "outlined-badge badge-indigo";
      break;
    default:
      badgeClass = "outlined-badge badge-gray";
  }
  return <span className={`badge  ${badgeClass}`}>{bookStatus}</span>;
};

const VendorCompleted = () => {
  const [bookings, setBookings] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [searchInput, setSearchInput] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const searchInputRef = useRef(null);
  const fetchBookings = async () => {
    try {
      const formData = {
        pageSize: 10,
        pageNo: 1,
        sParam: searchTerm,
        bookStatus: "",
        fromDate,
        toDate,
      };
      const response = await ongoingVendorService.completeVendor(formData);
      if (response.data.isSuccess) {
        setBookings(response.data.result);
      }
    } catch (error) {
      console.error("Error fetching bookings", error);
    }
  };

  useEffect(() => {
    fetchBookings();
  }, [fromDate, toDate]);
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };
  const handleSearchClick = () => {
    setSearchTerm(searchInput);
  };
  useEffect(() => {
    if (searchTerm !== "") {
      fetchBookings();
    }
  }, [searchTerm]);

  return (
    <div>
      <div className="">
        <h3>Completed Bookings Detalis</h3>
      </div>
      <div className="filter-row">
        <div className="mt-3">
          <Flatpickr
            id="fromDate"
            className="date-filters"
            placeholder="Select From Date"
            value={fromDate}
            onChange={([date]) => setFromDate(date)}
            options={{
              dateFormat: "Y-m-d",
              monthSelectorType: "static",
            }}
          />
        </div>
        <div className="mt-3">
          <Flatpickr
            id="toDate"
            className="date-filters"
            placeholder="Select To Date"
            value={toDate}
            onChange={([date]) => setToDate(date)}
            options={{
              dateFormat: "Y-m-d",
              monthSelectorType: "static",
            }}
          />
        </div>
        <div className="mt-3">
          <div className="search-input">
            <input
              type="text"
              id="search"
              className="date-filters"
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
              placeholder="Search...."
              ref={searchInputRef}
            />
          </div>
        </div>
        <div className=" mt-3">
          <div className="">
            <button
              className="date-filters btn orange-btn text-white"
              onClick={handleSearchClick}
            >
              Search
            </button>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-10 gap-4">
          {bookings.length === 0 ? (
            <div className="text-center mt-4">
              <h6>No Complete bookings available.</h6>
            </div>
          ) : (
            bookings.map((booking, index) => (
              <div
                key={booking.id}
                className="ongoning-details-card rounded-lg p-4 border mt-3"
              >
                <div className="ongoing-status flex justify-between items-center mb-2">
                  <h6 className="booking-details">
                    {booking.bookingNo} | {formatDate(booking.bookedOn)}
                  </h6>
                  <div>{renderBookStatusBadge(booking.bookStatus)}</div>
                </div>
                <div className="mb-1">
                  <h5>{booking.serviceName}</h5>
                </div>
                <div className="user-details mb-1">
                  Customer - {booking.userName} | {booking.contactNo}
                </div>
                <div className="mb-1 d-flex justify-content-end">
                  <div>
                    {booking.rating ? (
                      <div className="d-flex align-items-center mb-2">
                        {[1, 2, 3, 4, 5].map((star) => (
                          <span
                            key={star}
                            className={`fs-4 me-1 ${
                              star <= booking.rating
                                ? "text-warning"
                                : "text-secondary"
                            }`}
                          >
                            ★
                          </span>
                        ))}
                      </div>
                    ) : null}
                  </div>
                  <></>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default VendorCompleted;
